import React, { useState } from 'react';
import { styled, useTheme, Drawer, Divider, List, IconButton, ListItem, ListItemText, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';



const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100vw',
  padding: (0,4),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const itemList = [
  {
    text: "HOME",
    to: "/"
  },
  {
    text: "PRODUCTS",
    to: "/egress-window-products"
  },
  {
    text: "ABOUT",
    to: "/about"
  },
  {
    text: "EGRESS WINDOWS",
    to: "/egress-windows"
  },
  {
    text: "EGRESS BLOG",
    to: "/egress-blog"
  },
  {
    text: "CONTACT",
    to: "/contact"
  }
  
];


const DrawerItem = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleListItemClick = () => {
    handleDrawerClose();
  };

  return (
    <>
      <Drawer
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          width:'100vw',
          fontSize: '30px'
        }}
        variant="persistent"
        anchor="right"
        width='100vw'
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {itemList.map((item) => {
            const { text, to } = item;
            return (
              <ListItem
                key={text}
                component={Link}
                to={to}
                onClick={handleListItemClick}
                sx={{
                  fontSize: '30px',
                  color: '#ffffff',
                  "&:hover": {
                    backgroundColor: '#0deb2a!important',
                    color: '#ffffff',
                  }
                }}
              >
                <ListItemText primary={text} sx={{fontSize: '30px', margin: '0px auto'}} />
              </ListItem>
            );
          })}
        </List>
        <Box>
        <a href='stories'>
        <Button width= '100%' height='60px' sx={{color: '#ffffff',  backgroundColor: '#00AD14', textDecoration: 'none', borderRadius: '40px', width: '20px', height: '35px', marginLeft: '10px', padding: '0px auto', lineHeight: '1'}}>
        <ViewCarouselIcon fontSize={'20px'} sx={{color:'#ffffff'}}></ViewCarouselIcon></Button></a>
        <a href='videos'>
        <Button width= '100%' height='60px' sx={{color: '#ffffff',  backgroundColor: '#00AD14', textDecoration: 'none', borderRadius: '40px', width: '20px', height: '35px', marginLeft: '10px', padding: '0px auto', lineHeight: '1'}}>
        <PlayCircleIcon fontSize={'20px'} sx={{color:'#ffffff'}} ></PlayCircleIcon></Button></a>
        </Box>
      </Drawer>
      

      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="end"
        onClick={handleDrawerOpen}
        sx={{
          position: 'absolute',
          right: 0,
          top: 0,
        }}
      >
        <MenuIcon />
      </IconButton>
    </>
  );
};

export default DrawerItem;




/*
import React, { useState } from 'react';
import { styled, useTheme, Drawer, Divider, List, IconButton, ListItem,  ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'absolute',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const itemList = [
  {
    text: "Home",
    to: "/"
  },
  {
    text: "About",
    to: "/about"
  },
  {
    text: "Contact",
    to: "/contact"
  }
  
];

const DrawerItem = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    if (!open) {
      setOpen(true);
    }
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleListItemClick = () => {
    handleDrawerClose();
  };

  return (
    <>
      <Drawer
        sx={{
          position: 'absolute',
          zIndex: theme.zIndex.drawer + 1,
          width: drawerWidth
        }}
        variant="persistent"
        anchor="right"
        width= {drawerWidth}
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {itemList.map((item) => {
            const { text } = item;
            return (
              <ListItem
                key={text}
                component={Link}
                to={item}
                onClick={handleListItemClick} // Added onClick event handler
                sx={{
                  color: '#ffffff',
                  "&:hover": {
                    backgroundColor: '#0deb2a!important',
                    color: '#ffffff',
                  }
                }}
              >
                <ListItemText primary={text} />
              </ListItem>
            )
          })}
        </List>
      </Drawer>

      <IconButton
        color="#ffffff"
        aria-label="open drawer"
        edge="end"
        onClick={handleDrawerOpen}
        sx={{
          position: 'absolute',          
          right: 0,
          top: 0,
        }}
      >
        <MenuIcon />
      </IconButton>
    </>
  )
}

export default DrawerItem;


/*

import React, { useState } from 'react';
import { styled, useTheme, Drawer, Divider, List, IconButton, ListItem,  ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'absolute',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const itemList = [
  {
    text: "Home",
    to: "/"
  },
  {
    text: "About",
    to: "/about"
  },
  {
    text: "Contact",
    to: "/contact"
  }
  
];

const DrawerItem = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleListItemClick = () => {
    handleDrawerClose();
  };

  return (
    <>
      <Drawer
        sx={{
          position: 'absolute',
          zIndex: theme.zIndex.drawer + 1,
        }}
        variant="persistent"
        anchor="right"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {itemList.map((item) => {
            const { text } = item;
            return (
              <ListItem
                key={text}
                component={Link}
                to={item.to}
                onClick={handleListItemClick} // Added onClick event handler
                sx={{
                  color: '#ffffff',
                  "&:hover": {
                    backgroundColor: '#0deb2a!important',
                    color: '#ffffff',
                  }
                }}
              >
                <ListItemText primary={text} />
              </ListItem>
            )
          })}
        </List>
      </Drawer>

      <IconButton
        color="#ffffff"
        aria-label="open drawer"
        edge="end"
        onClick={handleDrawerOpen}
        sx={{
          position: 'absolute',
          right: 0,
          top: 0,
        }}
      >
        <MenuIcon />
      </IconButton>
    </>
  )
}

export default DrawerItem;

*/


